/**
 * Decide quale dettaglio documento aprire da un `document_id` grezzo (preso da un
 * evento `stock_in`). Il `document_id` può puntare a:
 *  - un DDT       → `public.documents` (sincronizzato nel master locale), source 'public'
 *  - una FATTURA  → `fiscal_archive`   (NON nel master locale),          source 'fiscal'
 *
 * Bug T-195: la tracciabilità instradava SEMPRE a 'public' → l'apertura delle
 * fatture falliva con "Documento non trovato". Regola corretta: se l'id è un DDT
 * noto localmente → 'public'; altrimenti → 'fiscal' (DocumentDetailPage interroga
 * `fiscal_documents` lato server). I document_id orfani (documento eliminato)
 * finiscono in 'fiscal' e danno un onesto "non trovato" a valle.
 *
 * `knownPublicDocIds` è una qualsiasi struttura con `.has(id)` (es. la `Map`
 * `docById` dei DDT in cache, o un `Set`).
 */
export function resolveDocSource(
  documentId: string,
  knownPublicDocIds: { has(id: string): boolean },
): 'public' | 'fiscal' {
  return knownPublicDocIds.has(documentId) ? 'public' : 'fiscal';
}
